import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { ReviewsDashboardComponent } from './dashboard/reviews-dashboard.component'
import { ConnectionGuard } from '@tv3/guards/connection.guard'
import { ChannelGuard } from '@tv3/guards/channel.guard'
import { ReviewsTableComponent } from './reviews/reviews-table.component'
import { RentalsPrimaryImageGuard } from '@tv3/guards/rentals-primary-image.guard'
import { ReviewWidgetComponent } from './review-widget/review-widget.component'
import { TemplateGuard } from '@tv3/guards/template.guard'
import { ReviewBookingsTableComponent } from './bookings/review-bookings-table.component'
import { DraftTaskGuard } from '@tokeet-frontend/tasks'

const routes: Routes = [
  {
    path: '',
    component: ReviewsDashboardComponent,
    canActivate: [ChannelGuard, ConnectionGuard, RentalsPrimaryImageGuard, TemplateGuard],
  },
  {
    path: 'list',
    component: ReviewsTableComponent,
    canActivate: [ChannelGuard, DraftTaskGuard, ConnectionGuard, RentalsPrimaryImageGuard, TemplateGuard],
  },
  {
    path: 'widget',
    component: ReviewWidgetComponent,
    canActivate: [ChannelGuard],
  },
  {
    path: 'bookings',
    component: ReviewBookingsTableComponent,
    canActivate: [ChannelGuard, ConnectionGuard, RentalsPrimaryImageGuard, TemplateGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReviewsRoutingModule {}
